export default {
    name: 'v-button',
    props: {
        type: {
            default: 'primary'
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        loading: {
            type: Boolean,
            default: false,
        },
        submit: {
            default: false,
        },
    },
    components: {
    },
}



// WEBPACK FOOTER //
// ./src/components/ext/button/button.js